import { Box, Tab, Tabs, Typography } from "@mui/material";
import { useState } from "react";
import searchIcon from "../../assets/setting/profile/search-icon.png";
import "./profile.scss";
// import userIcon from "../../assets/profile/user-icon.png";
import BoxWrapper from "../../UI/wrapper/box/boxWrapper";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Profile = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <div className="profile">
      <h1>This is my Profile</h1>
      <div className="input-search-div">
        <input className="input-search" type="text" placeholder="Search" />
        <div className="search-icon">
          <img src={searchIcon} alt="search" />
        </div>
      </div>
      <div className="profile-images">
        <div></div>
      </div>

      <BoxWrapper sx={{ width: "100%" }}>
        <BoxWrapper sx={{ boxShadow: "-8px 8px 12px rgba(218, 222, 232, 0.4)" }}>
          <Tabs
            value={value}
            sx={{
              ".Mui-selected": { color: "#4C0027 !important" },
              ".MuiTabs-indicator": {
                backgroundColor: "#4C0027 !important",
                borderRadius: "0px 0px 5px 5px !important",
                height: "4px",
              },
            }}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Summary" {...a11yProps(0)} />
            <Tab label="Personal" {...a11yProps(1)} />
            <Tab label="Work" {...a11yProps(2)} />
            <Tab label="Financial" {...a11yProps(3)} />
          </Tabs>
        </BoxWrapper>
        <BoxWrapper sx={{ boxShadow: "-8px 8px 12px rgba(218, 222, 232, 0.4)" }}>
          <TabPanel value={value} index={0}>
            <div className="report-to">
              <span className="h6 color">Reports to:</span>
              <span>Alex Jmaes</span>
            </div>
          </TabPanel>
          <TabPanel value={value} index={1}>
            Item Two
          </TabPanel>
          <TabPanel value={value} index={2}>
            Item Three
          </TabPanel>
          <TabPanel value={value} index={3}>
            Item four
          </TabPanel>
        </BoxWrapper>
      </BoxWrapper>
    </div>
  );
};

export default Profile;
